import { render } from "./TabsList.vue?vue&type=template&id=cfa1b772&ts=true"
import script from "./TabsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabsList.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tabs/TabsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfa1b772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfa1b772', __exports__)) {
    api.reload('cfa1b772', __exports__)
  }
  
  module.hot.accept("./TabsList.vue?vue&type=template&id=cfa1b772&ts=true", () => {
    api.rerender('cfa1b772', render)
  })

}


export default __exports__